import ArrowLeft from './arrow-left';
import ArrowRight from './arrow-Right';
export { ArrowRight, ArrowLeft, };
//# sourceMappingURL=index.js.map